import { getId } from '@/store/utils'
import { DEFAULT_SECTION_TITLE, MAIN_SECTION_TITLE } from '../constants'
import { getChildElements, getOptionalChildText } from './dom'
import { type ParsedXmlImportNodeItem, parseNode } from './node'

export interface ParsedXmlImportSectionItem {
  id: string
  title: string
  nodes: ParsedXmlImportNodeItem[]
}

export const parseSections = (
  treeElement: Element
): ParsedXmlImportSectionItem[] => {
  const sectionElements = getChildElements(treeElement, 'section')

  return sectionElements.map((sectionElement, index) => ({
    id: getId(),
    title:
      getOptionalChildText(sectionElement, ['section_title']) ||
      (index === 0 ? MAIN_SECTION_TITLE : DEFAULT_SECTION_TITLE),
    nodes: getChildElements(sectionElement, 'node').map(parseNode),
  }))
}
